import { InjectionToken } from '@angular/core';

/**
 * Rotas públicas que não exigem autenticação.
 * O interceptor NÃO redireciona para /login quando o refresh falha e a URL atual é uma dessas rotas.
 * Configure no app.config.ts de cada app que tiver páginas públicas.
 *
 * Exemplo: { provide: PUBLIC_ROUTES, useValue: ['/'] }
 */
export const PUBLIC_ROUTES = new InjectionToken<string[]>('PUBLIC_ROUTES', {
  factory: () => [],
});

/**
 * Rota para onde redirecionar após o logout.
 * Padrão: '/login'
 * Para apps com home pública, configure como '/'.
 *
 * Exemplo: { provide: POST_LOGOUT_ROUTE, useValue: '/' }
 */
export const POST_LOGOUT_ROUTE = new InjectionToken<string>('POST_LOGOUT_ROUTE', {
  factory: () => '/login',
});
